﻿/**
* DevExpress Dashboard (_toolbar-extension.js)
* Version:  22.2.6
* Build date: Apr 17, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createToolbarSeparator = void 0;
function createToolbarSeparator() {
    return {
        cssClass: 'dx-dashboard-toolbar-separator'
    };
}
exports.createToolbarSeparator = createToolbarSeparator;
